import { render, staticRenderFns } from "./business-contacts.vue?vue&type=template&id=80154520&"
import script from "./business-contacts.vue?vue&type=script&lang=js&"
export * from "./business-contacts.vue?vue&type=script&lang=js&"
import style0 from "./business-contacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports